import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import VendorHeader from "./../../component/VendorHeader";
import VendorFooter from "./../../component/VendorFooter";
import { API_BASE_URL } from "../../utils/app_url";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";
import Sidebar from "../../component/Sidebar";
import { NotificationManager } from "react-notifications";


const AddCategory = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { langJson } = useLanguage();

  const [formData, setFormData] = useState({
    title: "",
  });
  const [categoryImage, setCategoryImage] = useState(null);
  const [signupStatus, setSignupStatus] = useState("");
  const [addBtnDis, setAddBtnDis] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCategoryImage(file);
    }
  };

  const onAddCategory = async () => {
    if (!formData.title.trim()) {
      NotificationManager.warning(langJson?.titleisrequired ?? "Title is required");
      return;
    }

    setAddBtnDis(true);
    setSignupStatus("");

    const fd = new FormData();
    fd.append("title", formData.title);
    if (categoryImage) {
      fd.append("image", categoryImage);
    }

    try {
      const response = await fetch(`${API_BASE_URL}products/admin/product-categories`, {
        method: "POST",
        body: fd,
        headers: {
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setSignupStatus(responseData.msg);
        NotificationManager.success(responseData.msg);
        setTimeout(() => {
          navigate("/admin/categories");
        }, 1000);
      } else {
        setSignupStatus(responseData.msg);
        NotificationManager.warning(responseData.msg);
        setAddBtnDis(false);
      }
    } catch (error) {
      console.error("Error adding category:", error);
      setAddBtnDis(false);
      setSignupStatus(langJson?.somethingwentwrong ?? "Something went wrong");
      NotificationManager.error(langJson?.somethingwentwrong ?? "Something went wrong");
    }
  };

  return (
    <div>
      <div className="dashHeader">
        <VendorHeader />
      </div>
      <div className="adminDash">
        <Sidebar />
        <div className="rightSide">
          <h2>{langJson?.addcategory ?? "Add Category"}</h2>

          <ul className="addAddress">
            <li className="fullWidth">
              <label>{langJson?.title}</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={(e) => setFormData(prev => ({ ...prev, title: e.target.value }))}
                placeholder="Enter category title"
              />
            </li>

            <li className="fullWidth">
              <label>{langJson?.image ?? "Image"}</label>
              <input
                type="file"
                onChange={handleImageChange}
                accept="image/*"
              />
              {categoryImage && <span>{categoryImage.name}</span>}
            </li>

            <li className="fullWidth saveBtn">
              <button type="button" disabled={addBtnDis} onClick={onAddCategory}>
                {addBtnDis ? langJson?.pleasewait : langJson?.savechanges}
              </button>
            </li>
            <span className="lgnStatus">{signupStatus}</span>
          </ul>
        </div>
      </div>
      <VendorFooter />
    </div>
  );
};

export default AddCategory;
